import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import {
  getHealthMetricsV2,
  getHealthMetricsByPaginationLink,
  HealthMetricsQueryParameters,
  healthMetricsV2Path,
} from '@leagueplatform/dashboard-api';

export function useGetHealthMetricsV2(params: HealthMetricsQueryParameters) {
  return useQuery(
    [healthMetricsV2Path, params],
    () => getHealthMetricsV2(params),
    {
      keepPreviousData: true,
      staleTime: Infinity,
    },
  );
}

export function useInfiniteHealthMetricsV2(
  params: Omit<HealthMetricsQueryParameters, 'from' | 'interval'>,
) {
  return useInfiniteQuery(
    [healthMetricsV2Path, params],
    ({ pageParam }) => {
      if (pageParam) {
        return getHealthMetricsByPaginationLink(pageParam);
      }
      return getHealthMetricsV2({
        ...params,
        interval: 'all',
      });
    },
    {
      getNextPageParam(lastPage) {
        if (!lastPage?.links?.next) {
          return undefined;
        }

        // TODO: Remove this string manipulation after the merge of
        // https://everlong.atlassian.net/browse/WEBPLAT-2249
        // Which will allow for the passing of a full URL to leagueFetch
        const { next } = lastPage.links;
        return next.slice(next.indexOf('/v2/'));
      },
    },
  );
}
